import { enableRequestDownloadOnReadOnlySelector, KpkMedia } from "@keepeek/commons";
import { getI18n } from "react-i18next";
import { selector } from "recoil";

import { configSectionComponentDownloadManagerSelector } from "../../config/selectors";
import {
  askDownloadElementIdsState,
  askDownloadFormState,
  askDownloadStepState,
} from "../atoms/askDownloads";

export const askDownloadElementIdsSelector = selector<KpkMedia["id"][]>({
  key: "AskDownloadElementIdsSelector",
  get: ({ get }) => get(askDownloadElementIdsState),
  set: ({ set, get }, newValue: KpkMedia["id"][]) => {
    const configDownloadManager = get(configSectionComponentDownloadManagerSelector);
    set(askDownloadElementIdsState, newValue);
    // Active the ask download step if we have ids to send for request download
    const shouldShowStep = configDownloadManager?.enableAskDownload && newValue.length > 0;
    set(askDownloadStepState, shouldShowStep);
  },
});

export const askDownloadReasonSelector = selector<string>({
  key: "AskDownloadReasonSelector",
  get: ({ get }) => {
    const { fields } = get(askDownloadFormState);
    return `${getI18n().t("download-manager.askDownload.usage.reason.label")}: ${fields.use} \n${
      fields.comment
    }`;
  },
});

export const requestDownloadIsEnableSelector = selector<boolean>({
  key: "RequestDownloadIsEnable",
  get: async ({ get }) => {
    const enableRequestDownloadTechProValue = await get(enableRequestDownloadOnReadOnlySelector);

    const configDownloadManager = get(configSectionComponentDownloadManagerSelector);
    if (
      enableRequestDownloadTechProValue &&
      configDownloadManager &&
      configDownloadManager.enableAskDownload
    ) {
      return true;
    }
    return false;
  },
});
